module.exports = __webpack_public_path__ + "logo2.png?571e991dcf87b80ed0fc794b4a212110";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo2.png
// module id = 32
// module chunks = 0